/**
 * head.js
 */

/*import lazySizes from 'lazysizes';
lazySizes.cfg.addClasses = true;
lazySizes.cfg.preloadAfterLoad = true;
lazySizes.cfg.lazyClass = 'u-lazyload';
lazySizes.cfg.preloadClass = 'u-lazypreload';
lazySizes.cfg.loadingClass = 'is-lazyloading';
lazySizes.cfg.loadedClass = 'is-lazyloaded';*/

// replace no-js class with js class
(function(h){
    h.className = h.className.replace('no-js', 'js');
})(window.document.documentElement);


window.onDCL = function(callback) {
    if (window.document.readyState == "complete" || window.document.readyState == "loaded") {
        callback(); return;
    }
    if (window.addEventListener)
        window.addEventListener('DOMContentLoaded', callback, false);
    else if (window.attachEvent)
        window.attachEvent('onload', callback);
    else window.onload = callback;
};

// fallback: show unstyled content if the main stylesheet hasn't been loaded for 3s
setTimeout(function(){
    window.document.body.style.visibility = 'visible';
    window.document.body.style.opacity = '1';
}, 3 * 1000);

import loadFontImport from '../vendor/fontloader/fontloader.js';
loadFont('as-asphaltbau', '/dist/css/fonts-woff.css', '/dist/css/fonts-woff2.css');
